/* eslint-disable react/forbid-component-props */
// Component file
import React from 'react';
import { Img } from '@/components/blocks/MaterialImage';
import { Box, BoxProps, Link, SxProps, Typography } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import {
	DpTooltipSX,
	DpContentCardSX,
	DpImageSX,
	DpLinkSX,
} from '@/components/blocks/DpLibrary/DpFloatingWhatsApp/style';

type DpFloatingCardProps = BoxProps & {
	href?: string;
	img: string;
	alt?: string;
	xscard?: SxProps;
	hover?: string;
	example?: boolean;
};

export const DpFloatingWhatsApp = ({
	href,
	img,
	alt,
	xscard,
	hover,
	example,
}: DpFloatingCardProps) => (
	<Box
		component="div"
		sx={combineSX([
			DpContentCardSX(example ?? false),
			...(Array.isArray(xscard) ? xscard : [xscard]),
		])}
	>
		<Link href={href || ''} sx={DpLinkSX}>
			<Img src={img} alt={alt || ''} sx={DpImageSX} />
		</Link>
		<Box component="div" sx={DpTooltipSX} className="tooltip">
			<Typography>{hover}</Typography>
		</Box>
	</Box>
);
